import SwipesPage from './SwipesPage';
export default SwipesPage;